import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ContinueButton from "../Registration/ContinueButton";
import UnderConstruction from "../assets/UnderConstruction.gif";
import LoginHeader from "../components/Login/LoginHeader";
import { motion } from "framer-motion";

const LoginRedirectTempPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.auth);

  return (
    <motion.div
      initial={{ opacity: 0.2, y: -5 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 5 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      <>
        <div className="flex min-h-screen bg-white">
          <LoginHeader
            isAuthenticated={isAuthenticated}
            registrationPage={true}
          />
          <section className=" w-full flex flex-col min-h-screen justify-start items-center py-10 px-6 mt-24">
            <header className="mb-24">
              <h1 className="text-3xl font-bold text-[#1D2639] text-center">
                Welcome {user?.firstName || ""}!
              </h1>

              <p className="text-base font-medium text-[#7E7E7E] text-center w-full mt-4">
                Thanks for logging in! You’re all set, but we’re still putting
                on the final touches. We’ll notify you as soon as we launch.
                Stay tuned — it won’t be long!
              </p>
            </header>
            <div className="p-6 max-w-md w-full flex flex-col items-center justify-center">
              <div className="flex justify-center mb-4">
                <img
                  src={UnderConstruction}
                  alt="Graphic animation"
                  width={298}
                  height={298}
                />
              </div>

              <div className="flex flex-col justify-center items-center w-full sm:w-[572px]">
                <ContinueButton
                  onClick={() => navigate("/")}
                  label="Return to website"
                />
              </div>
            </div>
          </section>
        </div>
      </>
    </motion.div>
  );
};

export default LoginRedirectTempPage;
